import {inject, IReactComponent} from 'mobx-react';
import {AgentSettings} from './component';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.inviteStore?.agentSettingsController,
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const AgentSettingsComponent = inject(mapStoresToProps)(AgentSettings) as IReactComponent;

export default AgentSettingsComponent;
